<itl-image
  [title]="node.title"
  [description]="node.description"
  [required]="node.mandatory"
  (addImageButtonClicked)="addImage()"
>
  <div *ngFor="let image of images; let i = index" (click)="showEditImageActionSheet(i)" class="node-image">
    <img [src]="image.data" width="100" height="100" class="padding" style="margin: 5px;" />
  </div>
</itl-image>
<input
  #file
  type="file"
  name="name"
  accept=".jpg,.png"
  style="display: none;"
  (change)="handleFileOpenDialog($event)"
/>
<img #markerImageElement [src]="markerImage" style="visibility: hidden; position: absolute;" />
